var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-0 header__title py-2"},[_c('div',{staticClass:"row d-flex align-items-center"},[_c('div',{staticClass:"col-12"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }